const CM_PM_REGEX = new RegExp(/(project manager|capacity)/i);

export function isCmOrPm(jobTitle?: string): boolean {
  if (!jobTitle) return false;

  return CM_PM_REGEX.test(jobTitle);
}
